import { createSelector } from 'reselect'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'

const getMatchRouterSelect = createSelector(
  getRouteAndMatchRouterSelect,
  /**
   * @param {RouteMatch} routeAndMatch
   * @return {RouteMatch}
   */
  (routeAndMatch) => {
    return routeAndMatch?.match
  }
)

export default getMatchRouterSelect
